import { render, staticRenderFns } from "./FoodDistributionCoupons.vue?vue&type=template&id=4482c3d8&"
import script from "./FoodDistributionCoupons.vue?vue&type=script&lang=js&"
export * from "./FoodDistributionCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports